/**
 * RequestTypeService
 * Service for RequestType entity operations
 * Route: api/requesttype
 * Controller: RequestTypeController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestTypeService
 * Handles request type CRUD operations
 * Maps to /api/requesttype endpoint
 */
export class RequestTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestTypeService.DEFAULT_SERVICE_PATH,
            basePath: RequestTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestTypeService.DEFAULT_SERVICE_PATH = 'procurements';
RequestTypeService.BASE_PATH = 'api/requesttype';
//# sourceMappingURL=RequestTypeService.js.map